import getAxiosInstances from '@/lib/axios'
import { HelpRequestTypesResponse, LegacyParams } from '@/types/supports'

import { offerwallApi } from '../axiosInstance'

interface OriginalFormData {
  ad_id?: string
  app_id: string
  uid: string
  help_request_type_id: string
  email: string
  content: string
  sdk_ver: string
  os_ver: string
  attachments: File[]
  participated_at?: string
  reward_revoked_at?: string
  google_ad_id?: string
  idfa?: string
  device_model?: string
  key?: string
  request_id?: string
  action_id?: string
}

interface DynamicPersonalInfoData {
  name: string
  id: number
  code: string
  value: string
}

export interface SupportFormRequestData {
  originalFormData: OriginalFormData
  dynamicFormData?: DynamicPersonalInfoData[]
}

export const fetchHelpRequestTypes = async (params: LegacyParams): Promise<HelpRequestTypesResponse> => {
  const { data } = await offerwallApi.get<LegacyParams, HelpRequestTypesResponse>('/help_requests/help_request_types', {
    params: params,
    headers: {}
  })

  return data
}

export const submitSupportForm = async ({ originalFormData, dynamicFormData }: SupportFormRequestData) => {
  const formData = new FormData()

  const { attachments, ...rest } = originalFormData

  Object.entries(rest).forEach(([key, value]) => {
    formData.append(key, value as string)
  })

  if (dynamicFormData) {
    formData.append('help_request_personal_infos', JSON.stringify(dynamicFormData))
  }

  if (attachments.length > 0) {
    attachments.forEach((file, _) => {
      formData.append(`attachments[]`, file)
    })
  }

  const api = await getAxiosInstances()

  try {
    const { data } = await api.offerwallApi.post('/help_requests', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60 * 1000
    })

    return data
  } catch (error) {
    console.error('error >> ', error)

    throw error
  }
}
